export default __webpack_public_path__ + "static/media/Dan4o.ae5dc12f.png";